<template lang="pug">
  v-toolbar-items.pr-0.lang-selector
    v-menu(ref="langMenu" offset-y transition="slide-y-transition")
      v-btn.pr-3.px-0(large flat slot="activator" dark  @click="() => drawer = !drawer")
        v-layout(align-center justify-end row)
          v-flex.xs-10
            img.lang-flag(:src="icons[currentLocale]")
          v-flex.xs1.mx-1
            v-icon(v-if="refs.langMenu && refs.langMenu.isActive") expand_less
            v-icon(v-else) expand_more
      v-card
        v-list.menu-main-nav
          v-list-tile(
            v-for="lang in languages"
            :key="lang.code"
            @click="changeLanguage(lang.code)"
          )
            img.lang-flag.mr-2(:src="icons[lang.code]")
            | {{ lang.name }}
</template>


<script>
import enIcon from 'svg-country-flags/svg/gb.svg';
import frIcon from 'svg-country-flags/svg/fr.svg';

import { languages, defaultLanguage } from '@/main';

export default {
  name: 'RcLocaleSwitcher',
  data() {
    return {
      icons: {
        en: enIcon,
        fr: frIcon,
      },
      drawer: false,
      languages,
      currentLocale: defaultLanguage,
    };
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.i18next.changeLanguage(lang);
      this.currentLocale = this.$i18n.i18next.language;
    },
  },
  computed: {
    refs() {
      return this.$refs;
    },
  },
  mounted() {
    this.$forceUpdate();
  },
};
</script>

<style lang="scss">
.lang-selector {
  width: 8%;
  .v-menu {
    width: 100%;
    button {
      width: 100%;
    }
  }
}
.lang-flag {
  max-width: 24px;
}
</style>
